import React, { useState } from 'react';
import { TableRow, TableCell, TextField, IconButton, Typography } from '@mui/material';

interface EditComponentProps {
  row: {
    quantity: string;
    "item full description": string;
  };
  setEditSelect: (value: any) => void;
  setItems: (value: any[]) => void;
  index: number;
  Items: any[];
  handleCancel: () => void;
}

const EditComponent: React.FC<EditComponentProps> = ({ row, setEditSelect, setItems, index, Items, handleCancel }) => {
  const [editedText, setEditedText] = useState(row);
  
  const handleConfirmEdit = () => {
    let newArr = Items;
    let editItem = {
      ...Items[index],
      ...editedText
    };
    newArr[index] = editItem;
    setItems([...newArr]);
    setEditSelect(undefined);
  };

  const styleLeftAlign = {
    input: {
      inputProps: {
        style: {
          textAlign: 'right'
        }
      }
    }
  };

  return (
    <TableRow
      key={row["item full description"]}
      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
    >
      <TableCell component="th" scope="row" align='right'>
        <TextField
          onChange={(e) => setEditedText({ ...editedText, ["quantity"]: e.target.value })}
          variant='filled'
          defaultValue={row["quantity"]}
          sx={{
            '& .MuiInputBase-input': {
              textAlign: 'right'
            }
          }}
        />
      </TableCell>
      <TableCell component="th" scope="row" width={400} align='right'>
        <TextField
          fullWidth
          onChange={(e) => setEditedText({ ...editedText, ["item full description"]: e.target.value })}
          variant='filled'
          defaultValue={row["item full description"]}
          sx={{
            '& .MuiInputBase-input': {
              textAlign: 'right'
            }
          }}
        />
      </TableCell>
      <IconButton onClick={handleConfirmEdit} color='success'>
        <Typography component={'div'} fontWeight={700}>Confirm</Typography>
      </IconButton>
      <IconButton onClick={handleCancel} color='error'>
        <Typography component={'div'} fontWeight={700}>Cancel</Typography>
      </IconButton>
    </TableRow>
  );
};

export default EditComponent; 